import Vue from "vue";
import { Icon,Page,Table,Tooltip,Modal,Message } from 'view-design';
import { recordListAllColumns,delRecordVideoService,getRecordVideoListAllService } from '@/service/workflow-service'
Vue.component('Icon', Icon);
Vue.component('Page', Page);
Vue.component('Table', Table);
Vue.component('Tooltip', Tooltip);
const Collaboration = {
    name:'Collaboration',
    data() {
        return {
            recordListColumns:recordListAllColumns,
            quickVideoVisible:false,
            quickVideoInfoVisible:false,
            quickVideoInfo:{},
            quickUserList:[],
            recordArray:{},
            recordLoading:false,
            recordListHeight:0,
            quickNumber:1,
            recordParams:{
                search:'',
                currentPage: 1,  //当前页
                displayNumber:10 // 显示条数
            }
        }
    },
    created() {
        this.onTableHeight()
        this.onRecordListAll().then()
    },
    mounted() {
        window.addEventListener('resize', this.onTableHeight)
    },
    methods: {
        /**
         * 计算table高度
         */
        onTableHeight(){
            this.recordListHeight = window.innerHeight - 185
            // this.windowWidth = window.innerWidth
        },
        /**
         * 返回
         */
        onBack(){
            this.$emit('on-video-record-back');
        },
        /**
         * 重置
         */
        onReset() {
            this.recordParams.search = ''
            this.onRecordListAll().then()
        },
        /**
         * 搜索
         */
        onSearch(){
            this.onRecordListAll().then()
        },
        /**
         * 发送当前页
         * @param number
         */
        onSearchPage(number){
            this.recordParams.currentPage = number
            this.onRecordListAll().then()
        },
        /**
         * 发送每页显示的条数
         * @param number
         */
        onSearchPageSize(number){
            this.recordParams.displayNumber = number
            this.onRecordListAll().then()
        },
        /**
         * 删除
         * @param id
         */
        onDelete(id) {
            Modal.confirm({
                title: '提示',
                content: '<p>您确定要删除这条信息吗？</p>',
                onOk: () => {
                    this.onDeviceList(id).then()
                }
            });
        },
        /**
         * 查看视频
         * @param row
         */
        onLookVideo(row){
            this.quickNumber = 1
            this.quickUserList = []
            this.quickUserList = row.videoList
            this.quickVideoVisible = true
        },
        /**
         * 弹框关闭时
         * @param status
         */
        onVisiblePlayChange(status){
            if(!status && this.quickUserList.length!==0){
                if(!this.$refs['recordVideo'+(this.quickNumber-1)][0].paused){
                    this.$refs['recordVideo'+(this.quickNumber-1)][0].pause()
                }
            }
        },
        /**
         * 查看信息
         * @param row
         */
        onLookVideoInfo(row){
            this.quickVideoInfoVisible = true
            this.quickVideoInfo = row
        },
        /**
         * 上一页
         */
        onPreviousPage() {
            if(!this.$refs['recordVideo'+(this.quickNumber-1)][0].paused){
                this.$refs['recordVideo'+(this.quickNumber-1)][0].pause()
            }
            if(this.quickNumber > 1 && this.quickNumber <= this.quickUserList.length){
                this.quickNumber --
            }else{
                this.quickNumber = this.quickUserList.length
            }
        },
        /**
         * 下一页
         */
        onNextPage() {
            if(!this.$refs['recordVideo'+(this.quickNumber-1)][0].paused){
                this.$refs['recordVideo'+(this.quickNumber-1)][0].pause()
            }
            if(this.quickNumber >= 1 && this.quickNumber < this.quickUserList.length){
                this.quickNumber ++
            }else{
                this.quickNumber = 1
            }
        },
        /**
         * 拉取视频记录列表
         */
        async onRecordListAll() {
            try {
                this.recordLoading = true
                this.recordArray = {}
                let params = {
                    search:this.recordParams.search,
                    displayNumber:this.recordParams.displayNumber,
                    currentPage:this.recordParams.currentPage
                }
                const { code,data } = await getRecordVideoListAllService(params)
                if(code === 'SUCCESS'){
                    this.recordArray = data
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.recordLoading = false
            }catch (error){
                this.recordLoading = false
                console.log(error)
            }
        },
        /**
         * 删除设备信息
         */
        async onDeviceList(id) {
            try {
                let params = {
                    id:id
                }
                const { code } = await delRecordVideoService(params)
                if(code === 'SUCCESS'){
                    Message.success('删除成功！')
                    this.onRecordListAll().then()
                }else{
                    Message.error('请求异常，请联系管理员！')
                }

            }catch (error){
                console.log(error)
            }
        },
    },
    destroyed () {
        window.removeEventListener('resize',this.onTableHeight)
    }
}
export default Collaboration
